if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // --- START OF CUSTOM UPSELL LOGIC ---
        const productInfo = this.closest('product-info');
        const upsellContainer = productInfo ? productInfo.querySelector('.upsell-addon-container') : null;
        const selectedUpsells = upsellContainer ? upsellContainer.querySelectorAll('.upsell-addon-checkbox:checked') : [];

        if (selectedUpsells.length > 0) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const mainVariantInput = this.form.querySelector('input[name="id"]');
          const quantityInput = this.form.querySelector('input[name="quantity"]');
          const mainProductQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

          const items = [{
            id: mainVariantInput.value,
            quantity: mainProductQuantity
          }];
          
          selectedUpsells.forEach(checkbox => {
            const item = checkbox.closest('.upsell-addon-item');
            
            // ===== FIX IS HERE =====
            // Changed '.quantity__input' to '.upsell-addon-qty__input' to match the updated block code
            const quantityInput = item.querySelector('.upsell-addon-qty__input'); 
            
            const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
            
            items.push({ 
              id: checkbox.value, 
              quantity: quantity 
            });
          });
          
          const body = JSON.stringify({
            items: items,
            sections: this.cart.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          });

          fetch(`${routes.cart_add_url}`, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/javascript'
                  },
                  body: body
          })
          .then(response => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

          return; // Stop the original function from running
        }
        // --- END OF CUSTOM UPSELL LOGIC ---

        // --- ORIGINAL SUBMIT LOGIC (runs if no upsells are selected) ---
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}